import { Table } from "antd";
import { CALI_IGD, XL_IGD } from "constants/index";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";
import style from '../../index.module.scss'
import { useMemo } from "react";
import { groupBy, sortBy, sumBy, values } from "lodash";

const cx = classNames.bind(style)
export default function TableSushiIngredient({
    loading,
    data = [],
    type,
    cabinet,
    onlyVegetarian,
    renderQuantity,
    name,
}) {
    const { t } = useTranslation()

    const dataSource = useMemo(() => {
        const listIngredient = [];
        data.map(item => {
            item.box.ingredients.map(ingredient => {
                if (ingredient.ingredient.type === type) {
                    listIngredient.push({
                        quantity: item.quantity * ingredient.quantity,
                        quantityCabinet1: item.quantityCabinet1 * ingredient.quantity,
                        quantityCabinet2: item.quantityCabinet2 * ingredient.quantity,
                        quantityOrder: item.quantityOrder * ingredient.quantity,
                        name: ingredient.ingredient.name,
                        core: ingredient?.ingredient?.core || '',
                        shell: ingredient?.ingredient?.shell || '',
                        isVegetarian: ingredient?.ingredient?.isVegetarian
                    })
                }
            })
        })

        return listIngredient;
    }, [data, type])

    const dataRender = sortBy(sortBy(values(groupBy(dataSource.filter(item => onlyVegetarian ? item.isVegetarian : item), 'name')).map(groupedItem => {
        return {
            ...groupedItem[0],
            quantity: (renderQuantity.includes('shop') ? sumBy(groupedItem, 'quantity') : 0) +
                (renderQuantity.includes('cabinet1') ? sumBy(groupedItem, 'quantityCabinet1') : 0) +
                (renderQuantity.includes('cabinet2') ? sumBy(groupedItem, 'quantityCabinet2') : 0) +
                (renderQuantity.includes('boxOrder') ? sumBy(groupedItem, 'quantityOrder') : 0)
        }
    }).filter(item => item.quantity > 0), 'core'), function(o) { return !o.isVegetarian; })

    const handleOnCell = (record, title, dataIndex) => {
        return {
            record,
            className: record.isVegetarian ? cx('vegetarian') : '',
            dataIndex,
            title,
            style
        }
    }

    const columns = [
        {
            title: t('core'),
            dataIndex: "core",
            key: "core",
            render: (_) => {
                return (
                    <b style={{ fontSize: '16px' }}>{_}</b>
                );
            },
            onCell: (record) => handleOnCell(record, t('core'), 'core')
        },
        {
            title: t('shell'),
            dataIndex: "shell",
            key: "shell",
            render: (_) => {
                return (
                    <b style={{ fontSize: '16px' }}>{_}</b>
                );
            },
            onCell: (record) => handleOnCell(record, t('shell'), 'shell')
        },
        {
            title: t('quantity'),
            dataIndex: "quantity",
            key: "quantity",
            render: (_) => {
                return (
                    <b style={{ fontSize: '16px' }}>{_}</b>
                );
            },
            onCell: (record) => handleOnCell(record, t('quantity'), 'quantity')
        },
    ]

    return (
        <>
            <Table
            loading={loading}
            columns={type === CALI_IGD || type === XL_IGD ? columns : columns.filter(item => item.key !== 'shell')}
            dataSource={dataRender}
            size="small"
            pagination={false}
            summary={pageData => {
                let totalQuantity = 0;
                pageData.forEach(({ quantity }) => {
                    totalQuantity += quantity;
                });

                return (
                    <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={type === CALI_IGD || type === XL_IGD ? 2 : 1}>
                            <span style={{ fontWeight: 'bold' }}>{t('sum')}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>
                            <b style={{ fontSize: '16px' }}>{totalQuantity}</b>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                );
            }}
            bordered />
            <table id={name} border="1" style={{ display: 'none' }}>
                <tbody>
                    {dataRender.map((item, index) => (
                        <tr key={index}>
                            <td>{item.core}</td>
                            {
                                (type === CALI_IGD || type === XL_IGD) && <td>{item.shell}</td>
                            }
                            <td>{item.quantity}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}
